<template>
  <div id="app" :class="{ 'is-dark': darkThemeEnabled }">
    <div class="navbar__container">
      <div class="container">
        <header class="navbar">
          <div class="navbar-brand">
            <div class="navbar-item">
              <router-link to="/"><brand-logo light></brand-logo></router-link>
            </div>
            <div class="navbar-burger" data-target="main-nav">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="navbar-menu" id="main-nav">
            <div class="navbar-end">
              <div class="navbar-item">
                <summoner-search></summoner-search>
              </div>
            </div>
          </div>
        </header>
      </div>
    </div>
    <main class="section">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </main>
    <app-footer></app-footer>
  </div>
</template>

<script>
import state from './state'
import AppFooter from '@/components/AppFooter'
import BrandLogo from '@/components/BrandLogo'
import SummonerSearch from './components/SummonerSearch'

export default {
  name: 'app',

  components: {
    AppFooter,
    BrandLogo,
    SummonerSearch,
  },

  computed: {
    darkThemeEnabled () {
      return state.darkThemeEnabled
    },
  },
}
</script>

<style lang="sass">
@import 'sass/variables'
@import '~bulma'
@import 'sass/all'

html
  height: 100%

body
  margin: 0
  display: flex
  flex-direction: column
  flex: 1 0 auto
  min-height: 100vh

#app
  min-height: 100vh
  flex: 1 0 auto
  display: flex
  flex-direction: column
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-rendering: optimizeLegibility
  color: $text

  strong
    color: $text

main
  margin-top: 40px
  flex: 1 0 auto

.navbar
  .brand-logo-light
    font-size: 1.5rem
    font-weight: 500
    color: white
    span
      color: $primary

</style>



// WEBPACK FOOTER //
// App.vue?5ecf43f2